import { defineMessages } from 'react-intl';
import config from '@plone/volto/registry';
import textCenteredSVG from '@plone/volto/icons/align-center.svg';
import textLeftSVG from '@plone/volto/icons/align-left.svg';
import textRightSVG from '@plone/volto/icons/align-right.svg';

const messages = defineMessages({
  heading: {
    id: 'Heading',
    defaultMessage: 'Heading',
  },
  headingLevel: {
    id: 'Heading level',
    defaultMessage: 'Heading level',
  },
  alignment: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
  left: {
    id: 'Left',
    defaultMessage: 'Left',
  },
  center: {
    id: 'Center',
    defaultMessage: 'Center',
  },
  right: {
    id: 'Right',
    defaultMessage: 'Right',
  },
});

export const headingSchema = (props) => {
  const hide_alignment = config.blocks?.blocksConfig?.heading?.hide_alignment;
  const default_tag = config.blocks?.blocksConfig?.heading?.default_tag || 'h2';
  const allowed_headings =
    config.blocks?.blocksConfig?.heading?.allowed_headings;
  const DEFAULT_HEADING_LEVELS = [
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6'],
  ];

  const filterDefaultLevels = () => {
    if (allowed_headings) {
      return DEFAULT_HEADING_LEVELS.filter((item) =>
        allowed_headings.includes(item[0]),
      );
    } else {
      return DEFAULT_HEADING_LEVELS;
    }
  };

  return {
    title: props.intl.formatMessage(messages.heading),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          ...(allowed_headings.length > 1 ? ['tag'] : []),
          ...(hide_alignment ? [] : ['alignment']),
        ],
      },
    ],

    properties: {
      tag: {
        title: props.intl.formatMessage(messages.headingLevel),
        choices: filterDefaultLevels(),
        default: default_tag,
        noValueOption: false,
      },
      alignment: {
        title: props.intl.formatMessage(messages.alignment),
        default: 'center',
        required: false,
        type: 'string',
        widget: 'buttons',
        actions: ['left', 'center', 'right'],
        actionsInfoMap: {
          left: [textLeftSVG, props.intl.formatMessage(messages.left)],
          center: [textCenteredSVG, props.intl.formatMessage(messages.center)],
          right: [textRightSVG, props.intl.formatMessage(messages.right)],
        },
      },
    },
    required: [],
  };
};
